import ListClubMembersAdm from './ListClubMembers';

export default function ListClubTeam({ data }) {
    return <ListClubMembersAdm clubId={data?.id} />;
}
